import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Barcode = createSvgIcon(
  <path d="M2.2,3v18H0V3H2.2z M20.5,3v14.2h-2.2V3H20.5z M16.8,17.2V3h-2.2v14.2H16.8z M13.1,3v14.2h-2.2V3H13.1z M9.5,17.2V3H7.2v14.2H9.5z M5.9,3v14.2H3.6V3H5.9z M24,20.2V3h-2.2v17.2H24z" />,
  'Barcode'
);

export { Barcode };